<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('addPoi') }}</h2>
      <FormPointOfInterest @submit-requested="submitRequested"></FormPointOfInterest>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import FormPointOfInterest from '../forms/FormPointOfInterest.vue'

  export default {
  components: { FormPointOfInterest },
    methods: {
      ...mapActions('pois', ['addPoi']),
      submitRequested (inputPoi) {
        this.addPoi(inputPoi);
      },
    }
  }
</script> 
 
<style scoped>
</style> 